import ThemeToggle from '../Helper/ThemeToggle';
import { SidebarTrigger } from '@/components/ui/sidebar';
import { Menu, Search as SearchIcon } from 'lucide-react';
import { Search } from '../search';
import { useState } from 'react';
import ECILogo from '@/assets/images/ECI_Logo.png';
import NotificationDropdown from './NotificationDropdown';
import MobileSearchOverlay from './MobileSearchOverlay';
import ProfileDropdown from './ProfileDropdown';
import { useNavigate } from 'react-router-dom';
import ButtonCustom from '@/components/ButtonCustom';
import Breadcrumb from '@/components/Breadcrumb';

interface HeaderProps {
  isGuest?: boolean;
}

export default function Header({ isGuest = false }: HeaderProps) {
  const [isMobileSearchOpen, setIsMobileSearchOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <>
      <header className="relative flex min-h-[7.4rem] items-center justify-between overflow-hidden border-b border-b-[0.3px] border-b-[rgba(0,0,0,0.1)] bg-[#225AD6] px-[1.6rem] py-[1.2rem] lg:min-h-0 lg:overflow-visible lg:bg-[#FFFFFF] lg:px-[4rem] lg:py-[1.5rem] lg:dark:bg-[#091327]">
        <div className="flex w-1/2 relative z-[2] items-center gap-[1.2rem] lg:w-auto block lg:hidden">
          <SidebarTrigger className="text-[#FFFFFF] dark:text-[#FFFFFF] lg:hidden [&_svg]:!size-[2.4rem]">
            <Menu size={24} />
          </SidebarTrigger>
        </div>

        <div className="hidden lg:flex items-center">
          <Breadcrumb />
        </div>

        <div className="absolute right-[30%] top-[-35%] z-[1] h-[41.8rem] w-[42.4rem] rotate-[190deg] rounded-full bg-[linear-gradient(180deg,_rgba(247,250,252,0.4)_0%,_rgba(237,242,247,0)_100%)] opacity-16 lg:hidden" />

        <div className="logo pointer-events-none absolute left-1/2 top-1/2 z-[2] flex -translate-x-1/2 -translate-y-1/2 justify-center lg:hidden">
          <img
            className="h-auto w-[9.6rem] max-[360px]:w-[7.6rem] sm:w-[12rem]"
            src={ECILogo}
            alt="ECI Global"
          />
        </div>

        <div className="relative z-[2] flex shrink-0 items-center justify-end gap-[0.6rem] md:gap-[1.2rem] lg:w-auto lg:gap-[1.5rem]">
          {!isGuest ? (
            <>
              <Search
                variant="header"
                placeholder="Type to search..."
                className="hidden min-w-[30rem] dark:bg-[#212B3B] lg:flex"
              />

              <div className="hidden lg:block">
                <ThemeToggle />
              </div>

              <button
                type="button"
                onClick={() => setIsMobileSearchOpen(true)}
                className="flex !h-[4rem] !w-[4rem] shrink-0 items-center justify-center rounded-full bg-[#3463FD] text-[#FFFFFF] transition-colors duration-200 lg:hidden"
                aria-label="Open search"
              >
                <SearchIcon size={20} />
              </button>

              <NotificationDropdown />
              <ProfileDropdown />
            </>
          ) : (
            <>
              <NotificationDropdown isGuest compact />
              <ButtonCustom
                onClick={() => navigate('/login')}
                title="Login"
                className="!h-[3.2rem] rounded-[1rem] px-[1rem] text-[1.2rem] leading-[1.6rem] sm:px-[1.2rem] sm:text-[1.3rem]"
              >
                Login
              </ButtonCustom>
            </>
          )}
        </div>
      </header>

      {!isGuest && (
        <MobileSearchOverlay
          isOpen={isMobileSearchOpen}
          onClose={() => setIsMobileSearchOpen(false)}
        />
      )}
    </>
  );
}
